export function RemoveAccents(myString) {
  let newString = myString
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .replace(/\s+/g, "")
    .replace(/[^a-zA-Z0-9]/g, "")
    .toLowerCase();
  //console.log(myString, " | " + newString);
  return newString;
}

export async function SendMetric(myMetric) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: myMetric,
  };

  try {
    /* const response =  */ await fetch(
      "https://api.workobot.com/dev/planotipo",
      requestOptions
    );
    /* const json = await response.json(); */
    // console.log(json);
    // return json;
  } catch (error) {
    console.error("Catch Error: ", error);
    // return null;
  }
}

export function GetFileNameFromUrl(url) {
  const withoutQuery = url.split("?")[0];
  const filenameEncoded = withoutQuery.split("/").pop(); // Split by '/' and get the last part
  const filename = decodeURIComponent(filenameEncoded); // Decode URI encoding
  return filename;
}
